import React, { useState, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import { DatePicker } from "@material-ui/pickers";

import MakeAPICall from "../../apiCalls/common";

import { checkIfAbaFileAlreadyExportedApiRoute } from "../../apiRoutes";

import {
  getFutureDateByDays,
  getCurrDateInMomentV2,
  getFormattedDate
} from "../../utils/dateTimeHelper";

import Loader from "../../components/loader";
import Error from "../../components/error";
import Button from "../../components/button";
import Label from "../../components/label";

const AbaFileExport = props => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [selDate, setSelDate] = useState(null);
  const [errText, setErrText] = useState("");
  const [succText, setSuccText] = useState("");
  const [exportDateRange, setExportDateRange] = useState("");

  useEffect(() => {
    setIsProcessing(false);
    setApiCallParams(null);
    setSelDate(getCurrDateInMomentV2());
    setErrText("");
    checkIfAlreadyExported(getCurrDateInMomentV2());
  }, []);

  const checkIfAlreadyExported = date => {
    let sd = getFormattedDate(date);
    let ed = getFormattedDate(getFutureDateByDays(1, date));

    //display the range
    setExportDateRange("4.01am " + sd + " - 4.00am " + ed);

    // send the selected date at the backend
    let sd1 = getFormattedDate(date, "YYYY-MM-DD");

    let formData = new FormData();
    formData.append("exportDate", sd1);

    setApiCallParams({
      reqType: "POST",
      reqUrl: checkIfAbaFileAlreadyExportedApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        if (res.data.data === "Not Yet Exported") {
          setSuccText(res.data.data);
          setErrText("");
        } else {
          setErrText(res.data.data);
          setSuccText("");
        }
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrText("Some error occurred. Please try again!");
        // setSuccText("");
      }
    });
  };

  const doExport = () => {
    // send the selected date at the backend
    let sd1 = getFormattedDate(selDate, "YYYY-MM-DD");
    let formData = new FormData();
    formData.append("exportDate", sd1);

    if (props.onFormSubmit) {
      props.onFormSubmit(formData);
    }
  };

  return (
    <div className="w-100">
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <DatePicker
          autoOk
          orientation="landscape"
          variant="static"
          openTo="date"
          format="YYYY-MM-DD"
          disableFuture={true}
          value={selDate}
          onChange={date => {
            setSelDate(date);
            checkIfAlreadyExported(date);
          }}
        />
        <br />
        {exportDateRange && (
          <Fragment>
            <Label title={exportDateRange}></Label>
            <br />
          </Fragment>
        )}

        <span className="font-weight-bold success-msg">{succText}</span>
        <Error className="font-weight-bold">{errText}</Error>
        <br />
        <div className="d-flex flex-row justify-content-end">
          <Button clickEvent={doExport} title="Export ABA File" />
        </div>
      </div>
      <MakeAPICall apiParam={apiCallParams} />
    </div>
  );
};

export default AbaFileExport;

AbaFileExport.defaultProps = {
  onFormSubmit: () => {}
};

AbaFileExport.propTypes = {
  onFormSubmit: PropTypes.func
};
